// ServiceCard.jsx
import { Navigate, useNavigate } from 'react-router-dom';

const ServiceCard = ({ img, title, description, service }) => {
  const Navigate = useNavigate();

  const handleBooking = (s) => {
    Navigate(`/booking/${s.service_id}`, {
      state: {
        formField: s.formschema,
        name: s.service_name,
        id: s.service_id
      }
    });
  };

  return (
    /* Card Container: Fits full container column on mobile layouts naturally */
    <div className="w-full flex flex-col justify-between p-6 bg-white shadow-md border border-slate-100 rounded-xl hover:shadow-xl hover:shadow-[#1A3D6D]/10 transition-all duration-500">
      <div>
        {/* Responsive Image Frame */}
        <div className="w-full h-48 overflow-hidden rounded-lg md:h-52 bg-slate-100">
          <img
            src={`https://land-survey-main-server.onrender.com/services_images/${img}`}
            alt="service images"
            className="object-cover w-full h-full transition-transform duration-700 hover:scale-105"
          />
        </div>
        
        {/* Content Node */}
        <h3 className="mt-5 text-xl font-bold text-[#1A3D6D] tracking-tight">{title}</h3>
        <p className="mt-2 text-sm leading-relaxed text-slate-600 line-clamp-3">{description}</p>
      </div>

      {/* Button Action Matrix: Balanced flex engine prevents wrapping/overflow text layout damage on small screens */}
      <div className="flex items-center w-full gap-3 mt-6">
        <button 
          className="flex-1 py-2.5 px-4 bg-[#1A3D6D] text-white font-semibold text-sm rounded-lg hover:bg-[#1A3D6D]/90 transition-colors active:scale-95" 
          onClick={() => handleBooking(service)}
        >
          Book Now
        </button>
        <button 
        
          className="flex-1 py-2.5 px-4 border border-slate-300 text-slate-700 font-semibold text-sm rounded-lg hover:bg-slate-50 transition-colors active:scale-95"
          onClick={() => {
            Navigate('/explore');
          }}
        >
          Explore
        </button>
      </div>
    </div>
  );
};

export default ServiceCard;